export interface PointConfiguration {
    x: number;
    y: number;
}

export class Point {
    x: number;
    y: number;

    constructor({x, y}: PointConfiguration) {
        this.x = x;
        this.y = y;
    }
    static withCoordinates(x: number, y: number) {
        return new Point({x, y});
    }

    _apply({x, y}: PointConfiguration, fn: (a: number, b: number) => number) {
        return new Point({
            x: fn(this.x, x),
            y: fn(this.y, y),
        });
    }
    add(p: PointConfiguration) {
        return this._apply(p, (a, b) => a+b);
    }
    max(p: PointConfiguration) {
        return this._apply(p, Math.max);
    }
    min(p: PointConfiguration) {
        return this._apply(p, Math.min);
    }
}

export interface RectangleConfiguration {
    min: PointConfiguration;
    max: PointConfiguration;
}

export class Rectangle implements RectangleConfiguration {
    min: Point;
    max: Point;

    constructor({min, max}: RectangleConfiguration) {
        this.min = (min instanceof Point) ? min : new Point(min);
        this.max = (max instanceof Point) ? max :  new Point(max);
    }

    static fromPoint(p: PointConfiguration) {
        return new Rectangle({min: p, max: p});
    }

    expand(amt: number) {
        return new Rectangle({
            min: this.min.add({x: -amt, y: -amt}),
            max: this.max.add({x: amt, y: amt}),
        });
    }
    includePoint(p: PointConfiguration) {
        return new Rectangle({
            min: this.min.min(p),
            max: this.max.max(p),
        });
    }

    union(r: RectangleConfiguration) {
        return new Rectangle({
            min: this.min.min(r.min),
            max: this.max.max(r.max),
        });
    }

    get width() {
        return this.max.x - this.min.x;
    }
    get height() {
        return this.max.y - this.min.y;
    }
}